export enum PubSubTopics {
    CreateSubmission = "CreateSubmission",
    ResetSubmissionRoutes = "ResetSubmissionRoutes"
}
